export const zonasUTC = [
  {instituto: 0, zona: 'Etc/Greenwich', ciudad:''},
  {instituto: 1, zona: 'America/Mexico_City', diasEncuesta: 21, diasEncuestaPulse: 21},  //instituto MX
  {instituto: 2, zona: 'America/El_Salvador', diasEncuesta: 21, diasEncuestaPulse: 21},  //instituto CAyC
  {instituto: 3, zona: 'Hongkong', diasEncuesta: 14, diasEncuestaPulse: 14}, //instituto HK
  {instituto: 4, zona: 'Hongkong', diasEncuesta: 14, diasEncuestaPulse: 14}, //instituto SGP
  {instituto: 5, zona: 'Turkey', diasEncuesta: 14, diasEncuestaPulse: 14}, //instituto TK
  {instituto: 6, zona: 'Hongkong', diasEncuesta: 14, diasEncuestaPulse: 14}, //instituto FL
  {instituto: 8, zona: 'America/Mexico_City', diasEncuesta: 21, diasEncuestaPulse: 21}, //instituto FL
  {instituto: 11, zona: 'Brazil/East', diasEncuesta: 14, diasEncuestaPulse: 14}, //instituto BR
  {instituto: 14, zona: 'America/Mexico_City', diasEncuesta: 21,diasEncuestaPulse:14}, //instituto BR
  {instituto: 15, zona: 'Europe/Madrid', diasEncuesta: 14,diasEncuestaPulse:14}, //instituto ES
  {instituto: 18, zona: 'America/Mexico_City', diasEncuesta: 21,diasEncuestaPulse:14}, //instituto ES
  {instituto: 19, zona: 'America/Mexico_City', diasEncuesta: 21,diasEncuestaPulse:14, ciudad:'Ciudad de México'}, //instituto INNMOTION
  {instituto: 22, zona: 'Hongkong', diasEncuesta: 14, diasEncuestaPulse: 14}, //instituto HK 2
];

// import { zonasUTC } from 'app/main/pagina/zonasUtc';
